import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AutorenewIcon from '@mui/icons-material/Autorenew';

function ErrorDetailsBox({ invoice, onEditClick }) {
    if (!invoice.errorDetails) return null;

    return (
        <Box sx={{
            mt: 2,
            p: 2,
            backgroundColor: invoice.errorDetails.severity === 'ERROR' ? '#FFEBEE' : '#FFF3E0',
            borderRadius: 2,
            border: `1px solid ${invoice.errorDetails.severity === 'ERROR' ? '#EF5350' : '#FFB74D'}`,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 2
        }}>
            <WarningAmberIcon
                sx={{
                    color: invoice.errorDetails.severity === 'ERROR' ? '#C62828' : '#E65100',
                    fontSize: 24,
                    flexShrink: 0,
                    mt: 0.5
                }}
            />
            <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle2" sx={{
                    fontWeight: 'bold',
                    color: invoice.errorDetails.severity === 'ERROR' ? '#C62828' : '#E65100',
                    mb: 1
                }}>
                    {invoice.errorDetails.hebrewMessage}
                </Typography>
                <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.5 }}>
                    {invoice.errorDetails.tooltip}
                </Typography>
                {invoice.errorDetails.canEdit && (
                    <Button
                        variant="contained"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            onEditClick(invoice);
                        }}
                        sx={{
                            backgroundColor: invoice.errorDetails.severity === 'ERROR' ? '#C62828' : '#E65100',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: invoice.errorDetails.severity === 'ERROR' ? '#B71C1C' : '#D84315'
                            },
                            fontSize: '0.75rem',
                            px: 2
                        }}
                        startIcon={<AutorenewIcon sx={{ fontSize: 16 }} />}
                    >
                        טפל בשגיאה
                    </Button>
                )}
            </Box>
        </Box>
    );
}

export default ErrorDetailsBox;
